import { MBIconV2Name } from '@shared/components/image';
import { isScheduledAutomationComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class ScheduledAutomationFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<MBAPI.WorkflowTemplate_components_ScheduledAutomationComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    _reservedIds: Array<string>,
  ): boolean {
    return isScheduledAutomationComponent(component);
  }

  canBeAdded(_components: MBAPI.WorkflowTemplate_components[]): boolean {
    return true;
  }
}
